/** @format */

import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const TitlePropTypes = exact({
  value: PropTypes.string.isRequired,
});

export default TitlePropTypes;
